import { toast } from "react-toastify";
import i18next from "i18next";

export const displayError = (error) => {
	const errorTitle = Object.keys(error.response.data.errors)
    const params = error.response.data.errors[errorTitle]

    const message = params !== null
      ? i18next.t(errorTitle, { ...params }) // function with args: {{0}}, {{1}}, ...
      : i18next.t(errorTitle)

    // Detailed (multi-line) errors list the problematic records of the uploaded file,
    // so keep the line breaks and leave the toast open until the user closes it.
    const isDetailed = message.includes("\n")

    toast.error(message, {
      autoClose: isDetailed ? false : 10000,
      style: isDetailed ? { whiteSpace: "pre-line" } : undefined,
    });
}
